// extracted by mini-css-extract-plugin
export default {"container":"info_container__9w6Qs","title":"info_title__M2n9G","item":"info_item__c8UbN","step":"info_step__dmNEq","icon":"info_icon__QhS+E"};